import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accesodenegado',
  templateUrl: './accesodenegado.component.html',
  styles: []
})
export class AccesoDenegadoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
